import React from 'react';

import {BackLink} from '../../BackLink';
import {Chip} from '../Chip';
import {AgentStatus} from '../QueueDetail/AgentStatus';
import {EntityChip} from '../Queues/EntityChip';
import {Agent} from '../utilTypes';
import * as S from './AgentDetailHeader.styles';

type AgentDetailHeaderProps = {
  entityName: string;
  agent: Agent;
};

export const AgentDetailHeader = ({
  entityName,
  agent,
}: AgentDetailHeaderProps) => {
  const {name, agentStatus} = agent;

  return (
    <S.AgentHeader>
      <div>
        <BackLink to="/launch" text="Launch" />
        <S.AgentNamePanel>
          <S.AgentName>{name}</S.AgentName>
          <EntityChip name={entityName} />
          <Chip icon="ghost-agent" label="Agent" />
          <AgentStatus value={agentStatus} />
        </S.AgentNamePanel>
      </div>
    </S.AgentHeader>
  );
};
